import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../index.css";

const AboutDeveloper = ({ project }) => {
  const { handleShowModal } = useGlobalContext();
  return (
    <section className="section shadow-sm lazyloaded" id="developer">
      {/* <div className="d-block pt-2 pb-1 text-center">
        <img
          src="images/dosti-westcounty-logo.webp"
          width="auto"
          height="100%"
          loading="lazy"
          alt="Dosti Nest"
        />
      </div> */}
      <div className="row">
        <div className="col-md-8">
          <h1 class="d-block section-heading color-primary text-capitalize">
            About Developer
          </h1>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right d-none d-lg-block"
            onClick={handleShowModal}
          >
            Chat with us
          </button>
        </div>
      </div>

      <p>
        Dosti Realty is one of Mumbai's most trusted real estate developers,
        with a legacy of 40+ years, 129+ completed projects, and 15,800+ happy
        families. Known for its quality, innovation, and timely delivery, Dosti
        Realty has shaped some of the finest residential and commercial
        landmarks across Mumbai, Thane, and Pune. Dosti Nest at Dosti West
        County is designed to redefine urban living with world-class amenities
        and a thriving community.
      </p>

      <div class="rera-numbers">
        <div class="rera-item">
          <img src="images/rera-P51700033640.PNG" alt="rera qr" />
          <strong>P51700033640</strong>
        </div>
        <div class="rera-item">
          <img src="images/rera-P51700033663.PNG" alt="rera qr" />
          <strong>P51700033663</strong>
        </div>
        <div class="rera-item">
          <img src="images/rera-P51700049724.PNG" alt="rera qr" />
          <strong>P51700049724</strong>
        </div>
        <div class="rera-item">
          <img src="images/rera-P51700050253.PNG" alt="rera qr" />
          <strong>P51700050253</strong>
        </div>
      </div>

      <span className="pro-rera text-center-mob">
        {project} has been registered via MahaRERA registration number and is
        available on the website{" "}
        <a href="https://maharera.mahaonline.gov.in/">
          https://maharera.mahaonline.gov.in/
        </a>{" "}
        under registered projects.
      </span>

      <button
        className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale download_brochure float-lg-right mx-sm-auto d-lg-none"
        data-form="lg"
        data-title=" Chat with us"
        data-btn=" Chat with us"
        data-enquiry="Download Brochure Left Panel"
        data-redirect="enquiry"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={handleShowModal}
      >
        Chat with us
      </button>
    </section>
  );
};

export default AboutDeveloper;
